// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface SpecialEmphasisDataTableDTO extends EntitySelectorDTO { 
	id: number;
	code: string | null;
	name: string | null;
}

const SpecialEmphasisDataTableDTO = {
    className: 'SpecialEmphasisDataTableDTO',
    create: (initValues?: Partial<SpecialEmphasisDataTableDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: 0,
			code: "",
			name: "",
        },
        initValues);
    },
	id: 'id',
	code: 'code',
	name: 'name',
};

export default SpecialEmphasisDataTableDTO;